import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyBackgroundSounds: BaseKeyFunction = () => ["backgroundSounds"];
